package com.nonopn.skywatcher.design.menu

import androidx.compose.material3.DrawerDefaults
import androidx.compose.material3.DrawerState
import androidx.compose.material3.ModalNavigationDrawer
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection

@Composable
fun ModalNavigationRightToLeft(
    gesturesEnabled: Boolean,
    drawerState: DrawerState,
    scrimColor: Color = DrawerDefaults.scrimColor,
    drawerContent: @Composable () -> Unit,
    content: @Composable () -> Unit,
) {
    val originalDirection = LocalLayoutDirection.current
    val reversedDirection = when (LocalLayoutDirection.current) {
        LayoutDirection.Ltr -> LayoutDirection.Rtl
        LayoutDirection.Rtl -> LayoutDirection.Ltr
    }

    CompositionLocalProvider(LocalLayoutDirection provides reversedDirection) {
        ModalNavigationDrawer(
            drawerContent = { DrawerContentWrapper(originalDirection, drawerContent) },
            gesturesEnabled = gesturesEnabled,
            drawerState = drawerState,
            scrimColor = scrimColor
        ) {
            CompositionLocalProvider(LocalLayoutDirection provides originalDirection) {
                content()
            }
        }
    }
}

@Composable
private fun DrawerContentWrapper(
    layoutDirection: LayoutDirection,
    content: @Composable () -> Unit,
) {
    CompositionLocalProvider(LocalLayoutDirection provides layoutDirection) {
        content()
    }
}
